import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import NumberFormat from "react-number-format";

import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  cardHeader: {
    variant: "h1",
    fontSize: 20,
    fontWeight: 600,
  },
  labelTypo: {
    fontSize: 14,
    marginTop: 0,
    marginBottom: 2,
  },
  customIcon: {
    color: "#1c355e",
    height: 200,
    width: 200,
    opacity: 0.1,
  },
  cardSpace: {
    [theme.breakpoints.up("sm")]: {
      margin: 24,
    },
    [theme.breakpoints.down("sm")]: {
      marginBottom: 24,
    },
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "left",
    height: 240,
    width: 300,
  },
  successText: {
    marginTop: -180,
    transform: "translate(0%, 0%)",
    overflow: "hidden",
    fontSize: "0.875rem",
    textAlign: "center",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      opacity: 0,
    },
  },
}));

let SuccessCard = ({ amountDue }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div>
      <Grid item className={classes.cardSpace}>
        <Paper className={classes.paper} elevation={2}>
          <Grid container direction="column">
            <Grid item>
              <Typography className={classes.cardHeader}>
                {t("securepay.thankYou")}
              </Typography>
            </Grid>
            <Grid item style={{ marginTop: 0, textAlign: "center" }}>
              <AttachMoneyIcon className={classes.customIcon} />
              <div className={classes.successText}>
                <p className={classes.labelTypo}>
                  {t("securepay.thankYouAfterPayment.0")}
                  <NumberFormat
                    value={amountDue}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"$ "}
                    xs={1}
                    decimalScale={2}
                    fixedDecimalScale={true}
                  />
                  .&nbsp;
                  {t("securepay.thankYouAfterPayment.1")}
                </p>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </div>
  );
};

SuccessCard.propTypes = {
  amountDue: PropTypes.number,
};

export default SuccessCard;
